import { useEffect, useRef } from 'react';

/**
 * A hook to perform a callback for function with a delay
 * @returns
 */
const useDebounceCallback = () => {
	// track args & timeout handle between calls
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

	// make sure our timeout gets cleared if
	// our consuming component gets unmounted
	useEffect(() => {
		return () => {
			clearTimeout(timeoutRef.current);
		};
	}, []);

	/**
	 *
	 * @param func The debounceable callback function
	 */
	const debounceCallback = (func: () => void, delay = 275) => {
		// Clean the old function before setting the new one
		clearTimeout(timeoutRef.current);

		timeoutRef.current = setTimeout(func, delay);
	};

	return debounceCallback;
};

export default useDebounceCallback;
